export default () => ({
  show: false,
  isLoading: true,
  onCancel: false,
  fullPage: true,
  car: {
    tower_id: null,
    unit_id: null,
    plate: null,
    model: null,
    color: null,
    status: true
  },
  cars: [],
  entity: 'car',
  entities: 'cars',
  dwellerUnits: [],
  dwellerTowers: [],
  optionStatus: [
    {
      id: 'true',
      label: 'Ativo'
    },
    {
      id: 'false',
      label: 'Inativo'
    }
  ],
  prefixRouter: 'dweller.car'
})



// WEBPACK FOOTER //
// ./src/app/dweller/car/resources/data.js